import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import NavTooltipWrapper from "./NavTooltipWrapper";

const NavItem = ({
  to,
  label,
  Icon = null,
  collapsed = false,
  target = "",
  isDisabled = false,
  children = null,
  onClick = null,
  badge = null,
}) => {
  const handleClick = (e) => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (onClick) onClick(e);
  };

  const linkContent = (
    <NavLink
      to={to}
      target={target}
      end={to === "/"}
      className={({ isActive }) =>
        [
          "sidenav__link",
          isActive ? "is-active" : "",
          collapsed ? "is-collapsed" : "",
          isDisabled ? "is-disabled" : "",
        ]
          .filter(Boolean)
          .join(" ")
      }
      tabIndex={isDisabled ? -1 : undefined}
      aria-disabled={isDisabled ? "true" : undefined}
      onClick={handleClick}
    >
      <span className="sidenav__link__icon" aria-hidden="true">
        {Icon ? <Icon /> : null}
        {badge != null && badge > 0 && (
          <span className="sidenav__link__badge" data-testid="nav-item-badge">
            {badge}
          </span>
        )}
      </span>
      {!collapsed && <span className="sidenav__link__label">{label}</span>}
    </NavLink>
  );

  return (
    <NavTooltipWrapper collapsed={collapsed} label={label}>
      {linkContent}
      {children}
    </NavTooltipWrapper>
  );
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
  collapsed: PropTypes.bool,
  target: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  badge: PropTypes.number,
};

export default NavItem;
